import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openAnalyticsSubmenu } from '../sidebarHelpers';

const exploreMarketingChannelsTab = (baseUrl, navigate, user) => {
  return {
    id: 'exploreMarketingChannelsTab',
    title: 'Explore Marketing Channels Tab',
    steps: [
      {
        selector: `[data-tour="analyticsLink"]`,
        content: <p>Click on the "Analytics" section in the navigation.</p>,
      },
      {
        selector: `[data-tour="dashboardLink"]`,
        content: <p>Click on the "Dashboard" in the navigation.</p>,
        actionBefore: () => openAnalyticsSubmenu('[data-tour="dashboardLink"]'),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/analytics?mainTab=marketing`, true);
        },
        selector: '[data-tour="marketingTab"]',
        content: <p>Here you can see stats for all the marketing channels you use in Releva.</p>,
      },
      {
        selector: '[data-tour="summaryCardMarketingTab"]',
        content: (
          <p>Here you can see the numbers for the selected period compared to the numbers from the previous period.</p>
        ),
      },

      {
        selector: '[data-tour="emailsActivityChart"]',
        content: (
          <p>
            In the graphs below you can see the dynamics of sent messages via each channel and the subsequent user
            interactions.
          </p>
        ),
      },
      {
        selector: '[data-tour="emailBouncesCharts"]',
        content: (
          <>
            <p>
              Most stats in this section are self-explanatory, however, we'd like to give you some more details about
              the email bounces.
            </p>
            <p>
              When a particular recipient is unable to receive an email there are two types of reasons why - permanent
              and transient.
            </p>
            <p>
              A permanent bounce would be a mistyped email address, and a transient bounce would be if their mailbox is
              full.
            </p>
            <p>
              If an address bounces with a permanent error the system will not retry this address to avoid increasing
              your bounce rate unnecessarily.
            </p>
          </>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide?tab=exploreThePlatform`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find(
      (a) => a.action === 'taskCompleted' && a.context.task === 'exploreMarketingChannelsTab'
    ),
  };
};

export default exploreMarketingChannelsTab;
